/**
 * Content module for Majors Guide static pages
 * Provides type-safe access to JSON content files
 * @module MajorsGuide/content
 */

import collegeGuideData from './college-guide-content.json';
import gradSchoolGuideData from './grad-school-guide-content.json';
import majorsGuideData from './majors-guide-content.json';
import type { CollegeGuideContent, MajorsGuideContent, GradSchoolGuideContent } from './types';

// Export all types
export * from './types';

/**
 * Majors Guide static content
 */
export const majorsGuideContent = majorsGuideData as MajorsGuideContent;

/**
 * College Guide static content
 */
export const collegeGuideContent = collegeGuideData as CollegeGuideContent;

/**
 * Grad School Guide static content
 */
export const gradSchoolGuideContent = gradSchoolGuideData as GradSchoolGuideContent;
